import { Code2, Server, Sparkles, Workflow } from "lucide-react";
import { SKILLS } from "@/data/site";
import { MaskLines, Reveal, SectionLabel } from "@/components/Primitives";

const ICONS = { code: Code2, server: Server, workflow: Workflow, sparkles: Sparkles };

const SkillCell = ({ skill, index }) => {
  const Icon = ICONS[skill.icon] || Code2;
  return (
    <Reveal delay={index * 0.08} className="group relative flex h-full flex-col bg-ink p-8 transition-colors duration-500 hover:bg-coal sm:p-10" data-testid={`skill-category-${skill.id}`}>
      <span className="absolute inset-x-0 top-0 h-px origin-left scale-x-0 bg-gold transition-transform duration-700 group-hover:scale-x-100" />
      <div className="flex items-start justify-between">
        <span className="flex h-12 w-12 items-center justify-center border border-line text-ash transition-colors duration-500 group-hover:border-gold/60 group-hover:text-gold">
          <Icon size={20} strokeWidth={1.25} />
        </span>
        <span className="font-mono text-xs text-ash">0{index + 1}</span>
      </div>
      <h3 className="mt-10 font-serif text-3xl font-light text-ivory sm:text-4xl">{skill.title}</h3>
      <ul className="mt-8 flex flex-col">
        {skill.items.map((item) => (
          <li key={item} className="flex items-center gap-3 border-t border-line/70 py-3 text-ash transition-colors duration-300 hover:text-ivory">
            <span className="h-px w-3 bg-line-strong transition-[width,background-color] duration-500 group-hover:w-5 group-hover:bg-gold/70" />
            {item}
          </li>
        ))}
      </ul>
    </Reveal>
  );
};

export const Skills = () => (
  <section id="skills" className="border-t border-line bg-coal/40 py-28 sm:py-36 lg:py-44" data-testid="skills-section">
    <div className="container-x">
      <div className="grid grid-cols-1 items-end gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <SectionLabel index="02" label="Expertise" />
          <MaskLines lines={["Tools Behind", "the Work."]} className="mt-8 font-serif text-5xl font-light leading-[1] text-ivory sm:text-6xl lg:text-7xl" />
        </div>
        <Reveal as="p" className="max-w-md text-ash lg:col-span-4 lg:col-start-9">
          The languages, frameworks and tools I reach for — chosen for clarity, reliability and the problem at hand.
        </Reveal>
      </div>
      <div className="mt-20 grid grid-cols-1 gap-px border border-line bg-line md:grid-cols-2">
        {SKILLS.map((s, i) => <SkillCell key={s.id} skill={s} index={i} />)}
      </div>
    </div>
  </section>
);
